import config from "../../config";

const CheckAuth = () => {
  const isAuth = () => {
    const user = config.user;
    const token = config.token;
    const authStatus = user && token;
    return authStatus;
  };
  return isAuth();
};

export default CheckAuth;
